import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr, LZe
 */
import { Utils } from '@logio/common-be-fe';
import * as React from 'react';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import translate from '../../../../i18n/translate';
import CheckBoxGroup from '../../../../inputs/CheckBoxGroup';
import Filter from './Filter';
import FilterWrapper from './FilterWrapper';
import { Set } from 'immutable';
/**
 * Filter selecting number interval
 */

var CustomBooleanFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(CustomBooleanFilter, _Filter);

  function CustomBooleanFilter() {
    var _this;

    _classCallCheck(this, CustomBooleanFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CustomBooleanFilter).apply(this, arguments));
    _this.state = {
      valueType: ['true', 'false']
    };
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

    _this.setModel = function (model) {
      return _this.setState({
        valueType: model ? model.valueType : ['true', 'false']
      }, _this.props.filterChangedCallback);
    };

    _this.onCheckBoxGroupChange = function (valueType) {
      return _this.setState({
        valueType: valueType
      }, _this.props.filterChangedCallback);
    };
    /**
     * Resets input values and clears filter
     */


    _this.onClear = function () {
      return _this.setState({
        valueType: ['true', 'false']
      }, _this.closePopup);
    };

    _this.getTrueFilterTitle = function () {
      var filterParams = _this.props.colDef.filterParams;
      return translate(!Utils.isValueMissing(filterParams) && Utils.isString(filterParams.trueTitle) ? filterParams.trueTitle : 'filter-title-true');
    };

    _this.getFalseFilterTitle = function () {
      var filterParams = _this.props.colDef.filterParams;
      return translate(!Utils.isValueMissing(filterParams) && Utils.isString(filterParams.falseTitle) ? filterParams.falseTitle : 'filter-title-false');
    };

    return _this;
  }
  /**
   * This function determines wheter column's filter is active
   */


  _createClass(CustomBooleanFilter, [{
    key: "isFilterActive",
    value: function isFilterActive() {
      var valueTypeAsSet = Set(this.state.valueType);
      return Array.isArray(this.state.valueType) && valueTypeAsSet.size !== 2 && valueTypeAsSet.size !== 0;
    }
    /**
     * This function determines wheter each node passes the filter
     * In case of tree view this applies only from the lowest level
     * If there's a children matching filter, parent gets displayed even if it doesn't pass itself
     */

  }, {
    key: "doesFilterPass",
    value: function doesFilterPass(params) {
      if (this.state.valueType.includes('false') && this.state.valueType.includes('true')) {
        return true;
      }

      var value = this.props.valueGetter(params.node);

      if (this.state.valueType.includes('true')) {
        return !Utils.isValueMissing(value) && value;
      }

      if (this.state.valueType.includes('false')) {
        return Utils.isValueMissing(value) || !value;
      }

      return false;
    }
    /**
     * This function is for getColumnState() output and similar
     */

  }, {
    key: "getModel",
    value: function getModel() {
      return {
        valueType: this.state.valueType
      };
    }
    /**
     * Updates filter if value in floating filter changes
     * @param model object with filter state
     */

  }, {
    key: "onFloatingFilterChanged",
    value: function onFloatingFilterChanged(model) {
      if (!model) {
        this.setState({
          valueType: ['true', 'false']
        }, this.props.filterChangedCallback);
      } else {
        this.setState({
          valueType: model.valueType
        }, this.props.filterChangedCallback);
      }
    }
    /**
     * Renders filter component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: true
      }, React.createElement(CheckBoxGroup, {
        values: this.state.valueType,
        name: "alert-checkboxgroup-filter",
        options: [{
          label: this.getTrueFilterTitle(),
          value: 'true'
        }, {
          label: this.getFalseFilterTitle(),
          value: 'false'
        }],
        onChange: this.onCheckBoxGroupChange
      })));
    }
  }]);

  return CustomBooleanFilter;
}(Filter);

export { CustomBooleanFilter as default };